import React from 'react'
import LoginGateway from '../../components/LoginGateway/LoginGateway'
function LoginGateWayPage() {
  return (
    <LoginGateway/>
  )
}

export default LoginGateWayPage